export default "__VITE_ASSET__9sFBSe1e__"